var map = {
	"./Facebook.svg": 297,
	"./Insta.svg": 296,
	"./Linkedin.svg": 300,
	"./Twitter.svg": 298,
	"./Youtube.svg": 299,
	"./bncimagenes.png": 514,
	"./bonificaciones.png": 515,
	"./calendar.svg": 304,
	"./clientes.svg": 516,
	"./download.svg": 517,
	"./editar.svg": 305,
	"./editar_black.svg": 306,
	"./excel-logo.png": 307,
	"./manualmarca.png": 518,
	"./menu.svg": 303,
	"./precios.png": 519,
	"./presupuesto.svg": 520,
	"./vendedores.svg": 521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;